import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';

import type { HistoriesFileValidation } from '#backend/entity/loaded/harvest-history/HistoriesFileValidation';

@Component({
  selector: 'app-detail-history-validation',
  standalone: true,
  imports: [MatRadioModule, CommonModule],
  templateUrl: './detail-history-validation.component.html',
  styleUrl: './detail-history-validation.component.scss',
})
export class DetailHistoryValidationComponent {
  validation = input<HistoriesFileValidation>();
}
